const PlayerWalletActionType = {
  GET_PLAYER_WALLET_HISTORY: 'GET_PLAYER_WALLET_HISTORY',
  SAVE_PLAYER_WALLET_HISTORY: 'SAVE_PLAYER_WALLET_HISTORY',
  RESET_PLAYER_WALLET_HISTORY: 'RESET_PLAYER_WALLET_HISTORY',
  EXPORT_PLAYER_WALLET_HISTORY: 'EXPORT_PLAYER_WALLET_HISTORY',

  GET_PLAYER_WALLET_HISTORY_V2: 'GET_PLAYER_WALLET_HISTORY_V2',
  SAVE_PLAYER_WALLET_HISTORY_V2: 'SAVE_PLAYER_WALLET_HISTORY_V2',
  RESET_PLAYER_WALLET_HISTORY_V2: 'RESET_PLAYER_WALLET_HISTORY_V2',
  EXPORT_PLAYER_WALLET_HISTORY_V2: 'EXPORT_PLAYER_WALLET_HISTORY_V2',

  GET_PLAYER_WALLETS_INFO: 'GET_PLAYER_WALLETS_INFO',
  SAVE_PLAYER_WALLETS_INFO: 'SAVE_PLAYER_WALLETS_INFO',
  RESET_PLAYER_WALLETS_INFO: 'RESET_PLAYER_WALLETS_INFO',

  GET_PLAYER_WALLETS_INFO_V2: 'GET_PLAYER_WALLETS_INFO_V2',
  SAVE_PLAYER_WALLETS_INFO_V2: 'SAVE_PLAYER_WALLETS_INFO_V2',
  RESET_PLAYER_WALLETS_INFO_V2: 'RESET_PLAYER_WALLETS_INFO_V2',

  CHANGE_PLAYER_WALLETS_INFO_UPDATED_STATUS: 'CHANGE_PLAYER_WALLETS_INFO_UPDATED_STATUS',

  GET_PLAYER_EXTRA_WALLETS: 'GET_PLAYER_EXTRA_WALLETS',
  SAVE_PLAYER_EXTRA_WALLETS: 'SAVE_PLAYER_EXTRA_WALLETS',
  RESET_PLAYER_EXTRA_WALLETS: 'RESET_PLAYER_EXTRA_WALLETS',

  PLAYER_EXTRA_WALLETS_LOADING: 'PLAYER_EXTRA_WALLETS_LOADING',
  CHANGE_PLAYER_EXTRA_WALLETS_UPDATED_STATUS: 'CHANGE_PLAYER_EXTRA_WALLETS_UPDATED_STATUS',

  GENERATE_PLAYERS_REAL_WALLETS_SUM_REPORT: 'GENERATE_PLAYERS_REAL_WALLETS_SUM_REPORT',
};

export default PlayerWalletActionType;
